import { connect } from 'react-redux'
import {
  AdminRoute,
  CityManagerRoute,
  NotSpyRoute,
  PrivateRoute,
} from 'Config/Routing/auth'
import { PATHS } from 'Config/Routing/paths'
import CityPlanCreate from 'Containers/Campaigns/CityPlanCreate'
import BonusResults from 'Containers/Campaigns/Page/BonusResults'
import CityPlans from 'Containers/Campaigns/Page/CityPlans'
import Dashboard from 'Containers/Campaigns/Page/Dashboard'
import LiveMap from 'Containers/Campaigns/Page/LiveMap'
import ManagePaidAmounts from 'Containers/Campaigns/Page/ManagePaidAmounts'
import MasterSchedule from 'Containers/Campaigns/Page/MasterSchedule'
import { authorization } from 'Module/Auth/Auth'
import React, { Component } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import ClientQuestions from '../../Containers/Campaigns/Page/ClientQuestions/container/ClientQuestions'
import Codes from '../../Containers/Campaigns/Page/Codes/components/index'
import Conversions from '../../Containers/Campaigns/Page/Conversions/container/Conversions'
import CampaignDataHOC from './../../Containers/Campaigns/DataHOC'
import Mission from './../../Containers/Mission'
import CityPlanRouter from './CityPlanRouter'
import Logs from '../../Containers/Campaigns/Page/Logs'
import { InternalFilesRouter } from './InternalFilesRouter'
import { MailingListRouter } from './MailingListRouter'
import { getCampaignIdFromPath } from './Util'
import { getNextLink } from '../../Utils/Link'

const getNextRedirectionRoute = pathname => {
  const campaignId = getCampaignIdFromPath(pathname)

  const redirectionRoutes = ['artwork', 'artwork-and-offers']
  const defaultRoute = 'overview'

  const pathnameArray = pathname.split('/')
  const lastRoute = pathnameArray[pathnameArray.length - 1]

  const redirectionRoute =
    lastRoute && redirectionRoutes.includes(lastRoute)
      ? lastRoute
      : defaultRoute

  const path = `/dashboard/campaigns/${campaignId}/dashboard/${redirectionRoute}`
  return getNextLink(path)
}

class CampaignRouterRaw extends Component {
  render() {
    const regex = /campaigns\/(\d+)\/dashboard\/city-plan\/(\d+)/
    const isCityDashboard = regex.test(this.props.location.pathname)
    const isCityManagerAssistant = authorization.isCityManagerAssistant()

    const nextRedirectionRoute = getNextRedirectionRoute(
      this.props.location.pathname,
    )

    return (
      <Switch>
        {isCityDashboard ? (
          <Route path={`${this.props.match.path}${PATHS.campaign.dashboard}`}>
            <PrivateRoute>
              <Dashboard {...this.props} />
            </PrivateRoute>
          </Route>
        ) : (
          <Route
            path={`${this.props.match.path}${PATHS.campaign.dashboard}`}
            render={() => {
              window.location.href = nextRedirectionRoute
            }}
          />
        )}

        <Route
          path={`${this.props.match.path}${PATHS.campaign.metricsBreakdown}`}
          render={() => {
            const campaignId = getCampaignIdFromPath(
              this.props.location.pathname,
            )
            window.location.href = getNextLink(
              `/dashboard/campaigns/${campaignId}/metrics-breakdown`,
            )
          }}
        />
        <Route
          path={`${this.props.match.path}${PATHS.campaign.codeManagement}`}
          render={() => {
            const campaignId = getCampaignIdFromPath(
              this.props.location.pathname,
            )
            window.location.href = getNextLink(
              `/dashboard/campaigns/${campaignId}/code-management`,
            )
          }}
        />
        <Route
          path={`${this.props.match.path}${PATHS.campaign.detailedTracking}`}
          render={() => {
            const campaignId = getCampaignIdFromPath(
              this.props.location.pathname,
            )
            window.location.href = getNextLink(
              `/dashboard/campaigns/${campaignId}/detailed-tracking`,
            )
          }}
        />
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.cityPlans}`}
        >
          <PrivateRoute>
            <CityPlans {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.bonusResults}`}
        >
          <CityManagerRoute isNeedToHide={isCityManagerAssistant}>
            <BonusResults {...this.props} />
          </CityManagerRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.masterSchedule}`}
        >
          <PrivateRoute isNeedToHide={isCityManagerAssistant}>
            <MasterSchedule {...this.props} />
          </PrivateRoute>
        </Route>
        <Route exact path={`${this.props.match.path}${PATHS.campaign.liveMap}`}>
          <NotSpyRoute>
            <PrivateRoute
              isRestricted={
                !authorization.isCityManager() && !authorization.isClient()
              }
            >
              <LiveMap {...this.props} />
            </PrivateRoute>
          </NotSpyRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.managePaidAmounts}`}
        >
          <AdminRoute {...this.props}>
            <ManagePaidAmounts {...this.props} />
          </AdminRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.missionView}`}
        >
          <PrivateRoute>
            <Mission {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.rosterMissionView}`}
        >
          <PrivateRoute>
            <Mission {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${
            PATHS.campaign.letterboxMissionsMissionView
          }`}
        >
          <PrivateRoute>
            <Mission {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.missionEdit}`}
        >
          <PrivateRoute>
            <Mission {...this.props} editMode />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.url}${PATHS.campaign.rosterMissionEdit}`}
        >
          <PrivateRoute>
            <Mission {...this.props} editMode />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.url}${
            PATHS.campaign.letterboxMissionsMissionEdit
          }`}
        >
          <PrivateRoute>
            <Mission {...this.props} editMode />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.cityPlanCreate}`}
        >
          <CityManagerRoute>
            <CityPlanCreate {...this.props} />
          </CityManagerRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.clientQuestions}`}
        >
          <PrivateRoute>
            <ClientQuestions {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.mailingList}`}
        >
          <AdminRoute {...this.props}>
            <MailingListRouter {...this.props} />
          </AdminRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.internalFiles}`}
        >
          <AdminRoute {...this.props}>
            <InternalFilesRouter {...this.props} />
          </AdminRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.conversions}`}
        >
          <AdminRoute {...this.props}>
            <Conversions {...this.props} />
          </AdminRoute>
        </Route>
        <Route path={`${this.props.match.path}${PATHS.campaign.cityPlanView}`}>
          <PrivateRoute>
            <CityPlanRouter {...this.props} />
          </PrivateRoute>
        </Route>
        <Route exact path={`${this.props.match.path}${PATHS.campaign.codes}`}>
          <AdminRoute {...this.props}>
            <Codes {...this.props} />
          </AdminRoute>
        </Route>
        <Route exact path={`${this.props.match.path}${PATHS.campaign.logs}`}>
          <CityManagerRoute
            {...this.props}
            isNeedToHide={isCityManagerAssistant}
          >
            <Logs {...this.props} />
          </CityManagerRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.path}${PATHS.campaign.codesFAQ}`}
        >
          <PrivateRoute>
            <div>New Page</div>
          </PrivateRoute>
        </Route>
      </Switch>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  // Assuming the campaignId is available in ownProps from CampaignDataHOC
  const campaignId = ownProps.match.params.campaignId
  return {
    campaign: state.campaigns.campaigns[campaignId], // Make sure this matches how your state is structured
  }
}

const ConnectedComponent = connect(mapStateToProps)(CampaignRouterRaw)

export const CampaignRouter = withRouter(props => {
  return (
    <CampaignDataHOC campaignId={props.match.params.campaignId}>
      <ConnectedComponent {...props} />
    </CampaignDataHOC>
  )
})
